import * as getters from "../../baseQuestion/dynamicDDL/store/getters";
import * as mutations from "../../baseQuestion/dynamicDDL/store/mutations";
import * as actions from "../../baseQuestion/dynamicDDL/store/actions";
import { state as dynamic_ddl_state } from "../../baseQuestion/dynamicDDL/store/state";

function state() {
	return Object.assign(
		{
			dependent_visible: "q_mailing_country",
			dependent_visible_values: ["USA"],
			option_source: {
				type: "state",
				filter: []
			}
		},
		dynamic_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
